import * as types from "./actionTypes";

export const loadLanguage = (culture, dispatch) => {
  fetch(process.env.PUBLIC_URL + `/language.${culture}.json`)
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      dispatch({
        type: types.LANGUAGE_LOADED,
        payload: json,
      });
    });
};
